import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bnReplace' })
export class BnReplacePipe implements PipeTransform {
  transform(value: string, target: string, replacement: string): string {
    if (!value) {
      return '';
    }

    if (!target) {
      return value;
    }

    if (!replacement) {
      replacement = '';
    }

    if (target === '.') {
      return value.replace(/\./g, replacement);
    }

    const regex = new RegExp(target, 'g');
    return value.replace(regex, replacement);
  }
}
